import type { RefObject } from "react";
import { useCallback, useRef } from "react";

import type { Dropdown } from "@similarweb/ui-components";

type HookValue = {
    dropdownRef: RefObject<Dropdown<unknown> | null>;
    onUncontrolledOpen: VoidFunction;
    onUncontrolledClose: VoidFunction;
};

/* TODO remove when/if there is a controlled version of dropdown in ui-components  */
const useUncontrolledDropdown = (): HookValue => {
    const dropdownRef = useRef<Dropdown<unknown>>(null);

    const onUncontrolledOpen = useCallback(() => {
        // @ts-expect-error The Dropdown component is uncontrolled, but still we sometimes need to trigger open/close
        dropdownRef.current?.popupClickRef?.openPopup();
    }, []);

    const onUncontrolledClose = useCallback(() => {
        // @ts-expect-error The Dropdown component is uncontrolled, but still we sometimes need to trigger open/close
        dropdownRef.current?.popupClickRef?.closePopup();
    }, []);

    return { dropdownRef, onUncontrolledOpen, onUncontrolledClose };
};

export default useUncontrolledDropdown;
